import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import request from 'src/utils/request'

const initialState = {
  isLoading: false,
  isSuccess: false,
  usefulLinksData: [],
  error: '',
}

export const getUsefulLinks = createAsyncThunk(
  'usefulLinks/getUsefulLinks',
  async (_, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.student.token
      const res = await request(token).get(`/students/usefulLinks`)
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const wilayaSlice = createSlice({
  name: 'usefulLinks',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsefulLinks.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getUsefulLinks.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          usefulLinksData: action.payload,
          error: '',
        }
      })
      .addCase(getUsefulLinks.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
  },
})

export default wilayaSlice.reducer
